module.exports = __webpack_public_path__ + "img/sjqxkz.3c74e8c1.png";